import { getApiUrl } from '../config/api';
import { getAiChatFallbackReply } from '../utils/aiChatFallback';

export const sendAiChatMessage = async ({ messages, userName, pagePath }) => {
  const token = localStorage.getItem('token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers.Authorization = `Bearer ${token}`;

  const lastUser = [...(messages || [])].reverse().find((m) => m.role === 'user');
  const userText = lastUser?.content || '';

  try {
    const response = await fetch(getApiUrl('/api/ai/chat'), {
      method: 'POST',
      headers,
      body: JSON.stringify({ messages, userName, pagePath }),
    });

    const data = await response.json().catch(() => ({}));

    if (response.status === 404) {
      return {
        success: true,
        reply: getAiChatFallbackReply(userText),
        source: 'client-fallback',
      };
    }

    if (!response.ok) {
      throw new Error(data.message || 'Assistant unavailable.');
    }

    return data;
  } catch (err) {
    if (err.message?.includes('Failed to fetch') || err.name === 'TypeError') {
      return {
        success: true,
        reply: getAiChatFallbackReply(userText),
        source: 'client-fallback',
      };
    }
    throw err;
  }
};
